$(function () {
	console.log('logging');
});
